module.exports = __webpack_public_path__ + "static/media/fun-fact-bg.08df9b89.jpg";